<template>
  <div>
    <commonRecord :recordType="0"></commonRecord>
  </div>
</template>

<script>
  import commonRecord from '@/views/IM/model/commonRecord.vue'

  export default {
    name: 'intelligentRecord',
    components: { commonRecord }
  }
</script>
